(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxNetworkPrinterList(
     PrinterListPOSTPaging, PrinterListService, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        // context: '=context',
        tenant: '=tenant',
        network: '=network',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/networkProperties/networkPrinterList/networkPrinterList.template.html',
      link: function(scope) {

        scope.printerListPaging = new PrinterListPOSTPaging(); // inject 
        scope.noDataMessage = 'NoSearchResultPrinter';
        scope.currentDate = new Date();
        scope.thresholdToSwitchCreatedTimeFormat = 6;
        scope.printerContainer = null;

        (function() {
          getPrinterListPaged()
        })();

        function getPrinterListPaged () {
          scope.loadingPage = true;
          scope.printerListPaging.pagingCriteria.types = ['NETWORK','VIRTUAL'];
          scope.printerListPaging.pagingCriteria.networks = [scope.network.info._links.self.href];
          PrinterListService.postGetPrinterListPaged(scope.printerListPaging).then(function(printerContainer) {
            scope.printerContainer = printerContainer;
            scope.printerContainer = angular.copy(printerContainer);
          }).catch(function(err) {
          });
        };

        scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if (scope.printerListPaging.pagingCriteria.page > 0) {
              scope.printerListPaging.pagingCriteria.page--;
            }
          } else {
            if (scope.printerListPaging.pagingCriteria.page + 1 < scope.printerContainer.page.totalPages) {
              scope.printerListPaging.pagingCriteria.page++;
            }
          }
          getPrinterListPaged();
        }

        scope.refreshPrinterListPaged = function () {
          getPrinterListPaged();
        }

         ////////////////////////////////////////////
        ////////////////////////////////////////////
        // Context stuff
        ////////////////////////////////////////////

        scope.openContext = function (event, context, menuOption) {
          scope.closeAllMenues()
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContentPosition = { left: event.clientX, top: event.clientY }
            scope.contextPosition = { left: event.clientX, top: event.clientY }
            scope.contextContent = context;
            scope.context = context;
            scope.auxiliaries = {
              tenant: scope.tenant
            }; 
          }, 50)
        }

        scope.closeAllMenues = function() {
          scope.selectedContextMenuItem = null;
          scope.contextContentPosition = null;
          scope.contextPosition = null;
          scope.contextContent = null;
          scope.context = null;
          scope.auxiliaries = null; 
        }

      }
    };
  }

  pxNetworkPrinterList.$inject = [ 'PrinterListPOSTPaging', 'PrinterListService', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxNetworkPrinterList', pxNetworkPrinterList);

})();
